function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { sdkLogger } from '../../logger';
import { createErrorLoggingObservable } from '../../utils/observables/error-logging-observable';
export { AdTransitionType } from './bolt-ons.enums';
/*
[30/04/2020]
This bolt-on is responsible for surfacing transitions between
content and adverts to the player engine items. For specific ad-insertion
implementations, these transitions are not visible to the PEI
as they are surfaced by the addon at the session level.

This is currently required by the bitmovin PEI in order to clear subtitles
on content boundary due to a bug which causes the subtitles cue
end time to be incorrect. As a result, subtitles would remain on screen
for the duration of the advert, and often throughout the remainder of the
main content.
*/ export var SessionSideAdTransitionBoltOn = /*#__PURE__*/ function() {
    "use strict";
    function SessionSideAdTransitionBoltOn() {
        _class_call_check(this, SessionSideAdTransitionBoltOn);
        _define_property(this, "logger", sdkLogger.withContext('Session Ad Events'));
        _define_property(this, "adTransitionObservable", createErrorLoggingObservable('AdTransition', this.logger));
    }
    _create_class(SessionSideAdTransitionBoltOn, [
        {
            key: "notifyAdTransition",
            value: function notifyAdTransition(transitionType) {
                this.adTransitionObservable.notifyObservers(transitionType);
            }
        },
        {
            key: "onAdTransition",
            value: function onAdTransition(adTransitionObserver) {
                this.adTransitionObservable.registerObserver(adTransitionObserver, this);
            }
        }
    ]);
    return SessionSideAdTransitionBoltOn;
}();

//# sourceMappingURL=session-side-ad-transition-bolt-on.js.map